import { getCommercialCapabilitiesForRole } from "../../includes/pageInside/Rolle";
import { isProviderEcosystemPath } from "./drawerNavConfig";

// Which FILTER system the drawer shows, and whether it carries the Provider / Dropshipping In
// navigation. Decided from the ROUTE, the page type and the EFFECTIVE role's permissions -- never from
// the role alone (a Seller managing their shop and a Seller sourcing from Providers are two contexts).
//
//   HISTORIC (untouched components, no Provider navigation, no Provider state):
//     buyer           ELAKAY Filters          Home / catalogs / search / categories ... (Filter_fitlerP)
//     sellerShop      ELAKAY Filters Shop     a normal Seller shop seen by Buyers   (Filter_fitlerSU)
//     sellerProducts  ELAKAY Filter Products  Seller My Products                    (FilterUserProduct)
//   PROVIDER / DROPSHIPPING IN ecosystem (Elakay Navigation + context filters):
//     dropshippingIn    Provider Filters      /seller/providers, provider catalog/search, dropshipping-in
//     providerShop      Filters Shop          /seller/providers?providerId=..., /provider-shop/:id[/about]
//                                             (one Provider's products; the Provider itself on its own shop)
//     providerProducts  Filter Products       /provider/products (the Provider's own products)
//     none              ecosystem page without filters (orders, inventory, product preview...)
export const FILTER_CONTEXTS = Object.freeze({
  BUYER: "buyer",
  SELLER_SHOP: "sellerShop",
  SELLER_PRODUCTS: "sellerProducts",
  DROPSHIPPING_IN: "dropshippingIn",
  PROVIDER_SHOP: "providerShop",
  PROVIDER_PRODUCTS: "providerProducts",
  NONE: "none",
});

const DISCOVERY = /^\/seller\/(providers\/?$|provider-catalog|provider-search|dropshipping-in)/;
const OWNER_PRODUCTS = /^\/provider\/products\/?$/;
const PROVIDER_SHOP_SITE = /^\/provider-shop\/[^/]+/;

// Contexts that belong to the Provider / Dropshipping In ecosystem (the only ones that get Elakay Navigation).
export const isEcosystemContext = (ctx) => [FILTER_CONTEXTS.DROPSHIPPING_IN, FILTER_CONTEXTS.PROVIDER_SHOP, FILTER_CONTEXTS.PROVIDER_PRODUCTS, FILTER_CONTEXTS.NONE].includes(ctx);

// `pageType` is the Layout's `inpage` prop ("all" | "lakaUser" | "MyShop"): it tells the historic Buyer /
// Seller-shop / Seller-products pages apart. Provider routes never depend on it.
export const getFilterContext = ({ pathname = "", search = "", pageType = "all", activeRole } = {}) => {
  const caps = getCommercialCapabilitiesForRole(activeRole);
  if (DISCOVERY.test(pathname) && caps.canBrowseProviders) {
    const providerId = new URLSearchParams(search).get("providerId");
    return /^\/seller\/providers/.test(pathname) && providerId ? FILTER_CONTEXTS.PROVIDER_SHOP : FILTER_CONTEXTS.DROPSHIPPING_IN;
  }
  // The Provider storefront website: Sellers browsing it, and a Provider on its own storefront (the
  // route guard already refuses every other Provider / Royalty / User).
  if (PROVIDER_SHOP_SITE.test(pathname) && (caps.canBrowseProviders || caps.canAccessProviderCenter)) return FILTER_CONTEXTS.PROVIDER_SHOP;
  // The same website inside the Provider's own Customer View.
  if (/^\/provider\/my-shop\/?$/.test(pathname) && new URLSearchParams(search).get("view") === "customer" && caps.canManageProviderStorefront) return FILTER_CONTEXTS.PROVIDER_SHOP;
  if (OWNER_PRODUCTS.test(pathname) && caps.canManageProviderProducts) return FILTER_CONTEXTS.PROVIDER_PRODUCTS;
  // Other ecosystem pages need the capability of THEIR side (Seller->Providers or Provider Center).
  if (isProviderEcosystemPath(pathname) && (/^\/provider(\/|$)/.test(pathname) ? caps.canAccessProviderCenter : caps.canBrowseProviders)) return FILTER_CONTEXTS.NONE;
  if (pageType === "lakaUser") return FILTER_CONTEXTS.SELLER_SHOP;
  if (pageType === "MyShop") return FILTER_CONTEXTS.SELLER_PRODUCTS;
  return FILTER_CONTEXTS.BUYER;
};
